import React from 'react';
import { useIntl } from 'react-intl';

import { FiltersIcon } from './icons';
import { FilterButton, FilterCountBadge } from './styles';

interface ResourcesFilterButtonProps {
  /** How many filters are applied; the badge appears from one. */
  activeFilterCount: number;
  onClick: VoidFunction;
}

/**
 * The filter control of the redesigned resources page, in both of its views: the design's outlined
 * button with the count of what is applied.
 *
 * Where the count comes from is the caller's business — the map counts its sections, the list counts
 * the filters in the shared modal — which is why this holds no hook of its own.
 */
export const ResourcesFilterButton = ({ activeFilterCount, onClick }: ResourcesFilterButtonProps): JSX.Element => {
  const intl = useIntl();

  return (
    <FilterButton
      type="button"
      data-testid="resources-filter-button"
      aria-label={intl.formatMessage({ id: 'filters' })}
      aria-haspopup="dialog"
      isActive={activeFilterCount > 0}
      onClick={onClick}
    >
      <FiltersIcon />
      {activeFilterCount > 0 && (
        <FilterCountBadge data-testid="resources-filter-count">{activeFilterCount}</FilterCountBadge>
      )}
    </FilterButton>
  );
};
